import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    // State Objekt (z.B. gespeicherte Filter, Suchoptionen, Sortierungen etc.)
    state: {
        JourneyStore: [],
        JourneyStoreSingle: [],
        ContentStore: [],
        JourneyCategoryStore: [],
        Settings: {
            journeyoverview: {
                defaultsort: {
                    prop: 'date_from',
                    order: 'ascending'
                }
            }
        }
    },
    // Methoden um die States zu ändern (NICHT ASYNCHRON!)
    mutations: {
        listJourneys(state, data) {
            state.JourneyStore = data;
            state.JourneyStoreSingle = [];

            data.forEach(jrney => {
                jrney.dates.forEach(date => {
                    let _newJourney = JSON.parse(JSON.stringify(jrney))
                    _newJourney.dates = [date]
                    state.JourneyStoreSingle.push({
                        title: _newJourney.title,
                        date_from: date.date_from,
                        date_till: date.date_till,
                        duration: date.duration,
                        price: date.price,
                        id_jrn_journey: _newJourney.id_jrn_journey
                    });
                })
            });
        },
        listCategories(state, data) {
            data = data.sort((a, b) => a.name > b.name)
            state.JourneyCategoryStore = data;
            core.emit("updateJourney");
        },
    },
    // Wenn Asynchrone Aktionen erfolgen, dann als action aufrufen, um die Mutation zu triggern
    actions: {
        listJourneys({
            commit,
            state
        }) {
            core.backend("jrn.listJourneysWeb", {
                id_acc_account: 2,
                page_size: 999
            }, (err, res) => {
                commit('listJourneys', res.data.rows);
            })
        },
        listCategories(context) {
            core.backend("jrn.listCategoriesWeb", {
                id_acc_account: 2,
                page_size: 999
            }, (err, res) => {
                context.commit('listCategories', res.data.rows);
            })
        },
    },
    // Funktionen die im Zusammenhang mit State etwas returnen, z.B. wenn der State vorm holen noch behandelt werden muss
    getters: {}
})